import { Link } from "@/components/LocalLink";
import { IMAGES } from "@/data/catalog";

export const Hero = () => (
  <section className="hero" data-testid="hero">
    <img className="bg" src={IMAGES.truck} alt="The four founding dogs by the truck at the edge of the forest" style={{ objectPosition: "70% 55%" }} fetchpriority="high" />
    <div className="wrap"><div className="copy">
      <div className="eyebrow" data-testid="hero-eyebrow">The old ways · Made in Alberta</div>
      <h1 data-testid="hero-title">Small-batch mushroom powders for dogs.</h1>
      <p className="sub" data-testid="hero-subcopy">Turkey tail, reishi, cordyceps and lion's mane. One daily measure, every ingredient named, every batch numbered.</p>
      <div className="ctas">
        <Link to="/shop" className="btn btn-primary" data-testid="hero-shop">Shop the jars</Link>
        <Link to="/find-your-jar" className="btn btn-ghost" data-testid="hero-find-jar">Find your dog's jar</Link>
      </div>
      <div className="note" data-testid="hero-price-line">Four jars from $62 · Try all three for $29</div>
    </div></div>
  </section>
);
